<template>
    <div>
        <div class="card mb-4">
            <div class="card-header">
                <h2>Invoeren extra kosten {{ new Date(batch.created_at).toLocaleDateString('nl-NL', {month: 'long', year: 'numeric'}) }}</h2>
            </div>
            <div class="card-body">
                <div class="input-group" :class="{ 'has-invalid': $v.batch.extra_kosten.$error }">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input type="number" name="extra" id="extra" class="form-control" min="0"
                           v-model.lazy.number="$v.batch.extra_kosten.$model"
                           @focus="$v.batch.extra_kosten.$reset">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" v-if="!batch.goedgekeurd" @click="submit()">Goedkeuren</button>
                    </div>
                </div>
                <small class="form-text text-muted">
                    Wanneer de extra kosten niet voor de 19e van maand zijn ingevoerd wordt er vanuit gegaan dat er geen extra kosten zijn.
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import {numeric} from 'vuelidate/lib/validators';

export default {
    props: {
        batchProp: Object,
    },
    data() {
        return {
            batch: this.batchProp
        }
    },
    validations() {
        return {
            batch: {
                extra_kosten: {
                    numeric,
                }
            }
        }
    },
    methods: {
        submit() {
            if (!confirm('Weet je zeker dat je de balans voor deze maand wilt goedkeuren?')) {
                return false;
            }

            this.$v.$touch();

            let that = this;

            if (!this.$v.$invalid) {
                this.axios.post('/balans-goedkeuren/' + this.batch.id, {
                    'extra_expenses': this.batch.extra_kosten,
                    'current_deficit': this.batch.current_deficit,
                })
                    .then(function (response) {
                        that.$notify({
                            group: 'base',
                            text: 'De balans is goedgekeurd.',
                            type: 'alert-info',
                        });

                        that.batch.goedgekeurd = !that.batch.goedgekeurd;
                    })
                    .catch(function (error) {
                        let msg = error.response.data.message || error.response.data.error || 'Er is iets fout gegaan, probeer het a.u.b. opnieuw.';

                        that.$notify({
                            group: 'base',
                            text: msg,
                            type: 'alert-danger',
                        });

                        that.$v.$touch();
                    })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/AdditionalCost.vue